import { ConfirmationService } from '@confirmation/services/confirmation.service';
import { Component } from '@angular/core';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';

@Component({
  selector: 'app-offer-taken-container',
  templateUrl: './offer-taken-container.component.html',
  styleUrls: ['./offer-taken-container.component.scss'],
})
export class OfferTakenContainerComponent {
  constructor(
    public confirmationService: ConfirmationService,
    public readonly buildConfigService: BuildConfigService
  ) {}

  data = this.confirmationService.offerTakenData$;
  links = this.buildConfigService.config.header.links;
}
